import { db } from "./firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";

export const getNextQuotationNumber = async () => {
  const ref = doc(db, "Quotation_Counters", "Quotation");
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    await setDoc(ref, { currentNumber: 1 });
    return "QTN-0001";
  }

  const next = snap.data().currentNumber + 1;
  await updateDoc(ref, { currentNumber: next });

  return `QTN-${String(next).padStart(4, "0")}`;
};